import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class MaquinaFamiliaService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    obtenerTodos(callback) {
        this.gqlclient.query({
            query: gql `
        {
          maquina_familia {
            obtenerTodos {
              respuesta {
                registros {
                  codigo
                  nombre
                  descripcion
                }
              }
            }
          }
        }
        `,
            variables: {},
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.maquina_familia.obtenerTodos;
            callback({ mensajes, respuesta });
        });
    }
}
MaquinaFamiliaService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function MaquinaFamiliaService_Factory() { return new MaquinaFamiliaService(i0.ɵɵinject(i1.GraphQLClient)); }, token: MaquinaFamiliaService, providedIn: "root" });
